import useAZZKUYears from "hooks/AZZKU/useAZZKUYears";

import Options from "components/Options";
import Select from "components/Select";
import Loader from "components/Loader";
import { main_options, secondary_options, range_selects } from "../years";

export default function Step3({ params, errors, onChange }) {

   const { d: years } = useAZZKUYears({
      variable_id: params.variable_id,
      relation_id: params.relation_id,
      profession_ids: params.profession_ids
   });

   if ( years && !years.length )
      return <div className="error"> Brak danych dla wybranych zawodów. Wybierz inny zawód z listy filtrów </div>

   return years ? (
      <>
         <Options
            {...main_options }
            error={ errors.values_type }
            value={ params[ main_options.name ]}
            onChange={ onChange }
         />

         { params[ main_options.name ] === "raw" && 
            <Options
               multiple
               {...secondary_options }
               options={ years }
               error={ errors.years }
               value={ params[ secondary_options.name ]}
               onChange={ onChange }
            />
         }

         { params[ main_options.name ] === "dynamics_change" &&
            <>
               { range_selects.map(({ name, ...rest }) => {
                  const other_name = name === "base_year" ? "compare_year" : "base_year";
                  const filtered_years = years.filter( y => String(y.value) !== String(params[ other_name ]));
                  return (
                     <Select
                        key={ name }
                        name={ name }
                        value={ params[ name ]}
                        error={ errors[ name ]}
                        {...rest }
                        options={ filtered_years }
                        label_style={{ flex: "0 0 300px" }}
                        style={{ maxWidth: "800px" }}
                        onChange={ onChange }
                     />
                  );
               })}
            </>
         }
      </>
   ) : <Loader/>
}